import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'react-bootstrap';
import TextArea from './forms/TextArea';

const textareWithActionClasses =
  'block w-full resize-none border-0 bg-transparent text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:py-1.5 sm:text-sm sm:leading-6';

export default function TextAreaForm({
  className,
  id,
  name,
  actionName,
  onActionClick,
  onChange,
  placeholder,
  rows,
  value,
  disabled,
  disabledBtn,
}) {
  return (
    <div
      className={classnames('relative', className)}
      data-testid={`texAreaForm-${name}`}
    >
      <div className="overflow-hidden rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-green-600">
        <TextArea
          className={textareWithActionClasses}
          id={id}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          value={value}
          disabled={disabled}
        />
        {/* Spacer element to match the height of the tooPostlbar */}
        <div className="py-2" aria-hidden="true">
          {/* Matches height of button in toolbar (1px border + 36px content height) */}
          <div className="py-px">
            <div className="h-9" />
          </div>
        </div>
        <div className="absolute bottom-0 right-0 py-2 pr-2 pl-3">
          <Button
            bsStyle="green"
            onClick={onActionClick}
            disabled={disabledBtn}
            data-testid="actionButton"
          >
            {actionName}
          </Button>
        </div>
      </div>
    </div>
  );
}

TextAreaForm.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  disabledBtn: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  actionName: PropTypes.string,
  onActionClick: PropTypes.func.isRequired,
};

TextAreaForm.defaultProps = {
  actionName: 'Post',
  rows: 3,
  disabledBtn: false,
};
